<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<div class="form-group">
			<ejs-combobox v-model="data.user" id="user" :fields="fieldsSourceUsers" :dataSource='dataSourceUsers'  cssClass="e-outline" :placeholder="$t('textReports.textFormUser')"></ejs-combobox>
		</div>
		<div class="form-group">
			<ejs-combobox v-model="data.process" id="process" :dataSource='dataSourceProcess' :fields='fieldsSourceProcess' cssClass="e-outline" :placeholder="$t('textReports.textFormProcess')"></ejs-combobox>
		</div>
		<ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000">{{ $t('textBtn.btnSearch') }}</ejs-progressbutton>
	</form>
</template>

<script>
import axios from 'axios'
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
Vue.use(ProgressButtonPlugin);

export default {
	name: "reports-form-accomplishment",
	props: ['tittle'],
	data(){
		return {
			data: {
				user : null,
				process : null,
			},
			dataSourceUsers: [],
			fieldsSourceUsers: { text: "name", value: 'id' },
			dataSourceProcess: [],
			fieldsSourceProcess: { text: "nombre", value: 'id' },
			spinSettings: { position: 'Right', width: 20 },
			disabledButton :false,
			responseReport: false,
			activeFilters: []
		}
	},
	methods: {
		initFormAccomplishment: function() {
			this.dataSourceUsers = [];
			this.dataSourceProcess = [];
			axios.post('/auth/reports/getInitFormAccomplishment').then(response => {
				this.dataSourceUsers = response.data.users;
				this.dataSourceProcess = response.data.process;
			});
		},
		validateBeforeSubmit: function() {
			this.disabledButton = true;
            this.responseReport = false;
			this.$refs.progressBtn.enable;

			axios.post('/auth/reports/getReportsAccomplishment', {
				filter: true,
				user: this.data.user,
				process: this.data.process
			}).then(response => {
				var userSelect = document.getElementById('user').ej2_instances[0].itemData;
				var processSelect = document.getElementById('process').ej2_instances[0].itemData;

				if(this.data.user    !== null && this.data.user    !== "")  this.activeFilters.push('Usuario - ' + userSelect.name); 
				if(this.data.process !== null && this.data.process !== "")  this.activeFilters.push('Proceso - ' + processSelect.nombre);
				this.responseReport = true;
				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle ,response.data, this.activeFilters.join(' / '));
			});
		},
		progress: function() {
            if(this.responseReport){
                this.$refs.progressBtn.stop();       
            }
        }
	},
	created: function() {
		this.initFormAccomplishment();
      this.$eventHub.$on('onResetSwitchTenants', this.initFormAccomplishment);
	}
}
</script>